import Vue from 'vue'
import App from './App.vue'
import VueSwal from 'vue-swal'
Vue.use(VueSwal)

import { popupFocusFirstInput } from '@/mixins/common/popupFocusFirstInput'
Vue.mixin(popupFocusFirstInput)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import VueContentPlaceholders from 'vue-content-placeholders'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(VueContentPlaceholders)
Vue.use(Vuesax)

import VueTimeline from '@growthbunker/vuetimeline'
Vue.use(VueTimeline)
// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'

//loadash
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom', lodash })


//loadash


// Globally Registered Components
import './globalComponents.js'

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

import Pagination from 'vue-pagination-2'

Vue.component('VuePagination', Pagination)

import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

import 'flatpickr/dist/flatpickr.css'
Vue.component('flat-pickr', flatPickr)
Vue.component('vSelect', vSelect)

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueDraggable from 'vue-draggable'

Vue.use(VueDraggable)


import { Cropper } from 'vue-advanced-cropper'
Vue.use(Cropper)
// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: process.env.VUE_APP_GOOGLE_PLACE_API,
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})



import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
// vue moment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
  moment
})

//vue-js-infinte-loading
import InfiniteLoading from 'vue-infinite-loading'

Vue.use(InfiniteLoading)


//vue-js-infinte-load


//file agent 
import VueFileAgent from 'vue-file-agent'
// eslint-disable-next-line no-unused-vars
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
 
Vue.use(VueFileAgent)

//vue-resize
import { ResizeObserver } from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
Vue.component('resize-observer', ResizeObserver)

// Packery plugin
import VuePackeryPlugin from './plugins/vue-packery-plugin'
Vue.use(VuePackeryPlugin)

// Packery Draggabilly Plugin
import VueDraggabillyPlugin from './plugins/vue-packery-draggabilly-plugin.js'
Vue.use(VueDraggabillyPlugin)

import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: `${process.env.VUE_APP_GOOGLE_CLIENT_ID}.apps.googleusercontent.com`,
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

import ItemsPerTableDropdown from '@/components/common/ItemsPerTableDropdown'
Vue.component('ItemsPerTableDropdown', ItemsPerTableDropdown)

// import {PermissionMiddleware} from './mixins/middleware/PermissionMiddleware'

//file agent

//
// Vue.use(require('vue-moment'))
Vue.config.productionTip = false
import { repository } from '@/mixins/repository'

new Vue({
  router,
  store,
  i18n,
  acl,
  mixins: [repository],
  render: h => h(App)
  
}).$mount('#app')

// {{dATE|dateFormatLocalization}}

Vue.mixin({
  data () {
    return {
      configGlobalFlatPickr:{
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d'
      }
    }
  },
  /*  created () {
    const localizationFormat = JSON.parse(localStorage.getItem('localization'))
    const dateFormat =  [
      {
        id:1,
        value:'DD/MM/YY',
        key_val:'d/m/y'
        
      },
      {
        id:2,
        value:'DD/MM/YYYY',
        key_val:'d/m/Y'
        
      },
      {
        id:3,
        value:'MM/DD/YY',
        key_val:'m/d/y'
        
      },
      {
        id:4,
        value:'MM/DD/YYYY',
        key_val:'m/d/Y'
        
      },
      {
        id:5,
        value:'YYYY/MM/DD',
        key_val:'Y/m/d'
        
      },
      {
        id:6,
        value:'YYYY/DD/MM',
        key_val:'Y/d/m'
        
      }
    ]
    if ('date_format_id' in localizationFormat && localizationFormat.date_format_id) {
      console.log(localizationFormat)
      const date_format = dateFormat.filter(ele => ele.id === parseInt(localizationFormat.date_format_id))
      if (date_format.length) {
        this.configGlobalFlatPickr.altFormat = 'Y F, j'
        
      }
    }

  }, */
  methods: {
    successProp () {
      return {
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      }
    },
    errorProp () {
      return {
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }
    },
    warnProp () {
      return {
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      }
    },
    showSuccessMessage (title, success_text, color, timer = 3000) {
      this.$vs.notify({
        title,
        text: success_text,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color,
        time: timer
      })
    },
    ValidateEmail (mail) {
      if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
        return (true)
      }
      return (false)
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    validateTodayDate (todayDate, selectedDateParameter) {
      const today = moment(todayDate)
      const selectedDate = moment(selectedDateParameter)
      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    },
    checkingQuery (path) {
      if (this.$route.query && 'page' in this.$route.query && !isNaN(this.$route.query.page)) {
        this.meta.current_page = this.$route.query.page
      } else {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.page = 1
          
        this.$router.replace({
          path,
          query: queryPayload
        }).catch(() => {})
        
      }
    },
    //Custom date range for datepicker
    customDateRanges () {
      const today = this.$moment(new Date()).startOf('day').toDate()
      const yesterday = this.$moment(new Date()).subtract(1, 'days').startOf('day').toDate()
      const thisWeek = {
        start: this.$moment(new Date()).startOf('isoWeek').toDate(),
        end: this.$moment(new Date()).endOf('isoWeek').toDate()
      }
      const lastWeek = {
        start: this.$moment(new Date()).subtract(1, 'weeks').startOf('isoWeek').toDate(),
        end: this.$moment(new Date()).subtract(1, 'weeks').endOf('isoWeek').toDate()
      }
      const thisMonth = {
        start: this.$moment(new Date()).startOf('month').toDate(),
        end: this.$moment(new Date()).endOf('month').toDate()
      }
      const lastMonth = {
        start: this.$moment(new Date()).subtract(1, 'months').startOf('month').toDate(),
        end: this.$moment(new Date()).subtract(1, 'months').endOf('month').toDate()
      }
      const thisYear = {
        start: this.$moment(new Date()).startOf('year').toDate(),
        end: this.$moment(new Date()).endOf('year').toDate()
      }
      const lastYear = {
        start: this.$moment(new Date()).subtract(1, 'years').startOf('year').toDate(),
        end: this.$moment(new Date()).subtract(1, 'years').endOf('year').toDate()
      }

      return {
        'Today': [today, today],
        'Yesterday': [yesterday, yesterday],
        'This Week': [thisWeek.start, thisWeek.end],
        'Last Week': [lastWeek.start, lastWeek.end],
        'This Month': [thisMonth.start, thisMonth.end],
        'Last Month': [lastMonth.start, lastMonth.end],
        'This Year': [thisYear.start, thisYear.end],
        'Last Year': [lastYear.start, lastYear.end]
      }
    }
  },
  filters:{
    date_format_system_wise (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD-MM-YYYY')
    },
    dateFormatLocalization (date) {
      if (!date) {
        return ''
      }
      const localizationFormat = JSON.parse(localStorage.getItem('localization'))
      const dateFormat =  [
        {
          id:1,
          value:'DD/MM/YY',
          key_val:'d/m/y'
          
        },
        {
          id:2,
          value:'DD/MM/YYYY',
          key_val:'d/m/Y'
          
        },
        {
          id:3,
          value:'MM/DD/YY',
          key_val:'m/d/y'
          
        },
        {
          id:4,
          value:'MM/DD/YYYY',
          key_val:'m/d/Y'
          
        },
        {
          id:5,
          value:'YYYY/MM/DD',
          key_val:'Y/m/d'
          
        },
        {
          id:6,
          value:'YYYY/DD/MM',
          key_val:'Y/d/m'
          
        }
      ]
      // console.log(JSON.parse(localizationFormat))
      if ('date_format_id' in localizationFormat && localizationFormat.date_format_id) {
        // console.log(localizationFormat)
        const date_format = dateFormat.filter(ele => ele.id === parseInt(localizationFormat.date_format_id))
        // console.log(date_format[0].value)
        return moment(date).format(date_format[0].value)
      } return date
      /*   */
    },
    timeFormatLocalization (date) {
      // console.log(date)
      if (!date) {
        return ''
      } 
      
      const localizationFormat = JSON.parse(localStorage.getItem('localization'))
      /*  if ('time_format_id' in localizationFormat && localizationFormat.time_format_id) {
        if (localizationFormat.time_format_id === 1) {
          return moment(date, 'hh:mm A').format('hh:mm:ss')


        } else {
          return moment(date).format('HH:mm:ss')

        }
      } */            return moment(date).format('HH:mm')


    },
    OnlytimeFormatLocalization (date) {
      if (!date) {
        return ''
      } 
      
      const localizationFormat = JSON.parse(localStorage.getItem('localization'))
    
      if (localizationFormat.time_format_id === 1) {
        return moment(date, 'hh:mm A').format('hh:mm A')
      } else {
        return moment(date, 'hh:mm A').format('HH:mm')
      }
    },
    formatTimeAgo (date) {
      if (!date) {
        return ''
      }

      return moment(date).fromNow()
    }
  }
})

// Vue.mixin(PermissionMiddleware)